import { render, staticRenderFns } from "./secondReview.vue?vue&type=template&id=39cadd80&scoped=true"
import script from "./secondReview.vue?vue&type=script&lang=js"
export * from "./secondReview.vue?vue&type=script&lang=js"
import style0 from "./secondReview.vue?vue&type=style&index=0&id=39cadd80&prod&lang=scss&scoped=true"
import style1 from "./secondReview.vue?vue&type=style&index=1&id=39cadd80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cadd80",
  null
  
)

export default component.exports